export default "__VITE_ASSET__ff5002f1__"